export enum ButtonTypes {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  DANGER = 'DANGER',
  DISABLED = 'DISABLED',
}
export enum ButtonSizes {
  BIG = 'BIG',
  SMALL = 'SMALL',
}
